import {
  deletePageData,
  downloadData,
  getPageListData,
  getPostPageListData,
  notifyMe
} from '@/service/main/system'
import { IRootState } from '@/store/types'
import { ElMessage, ElNotification, ElLoading } from 'element-plus'
import { Module } from 'vuex'
import { ISystemState, MessageType } from '../type'
import { count } from 'echarts/types/src/component/dataZoom/history'

let isWindowFocused = true
let windowFocusListenersActive = false

const handleWindowFocus = () => {
  isWindowFocused = true
  console.log('窗口已获取焦点')
}

const handleWindowBlur = () => {
  isWindowFocused = false
  console.log('窗口已失去焦点')
}

const attachWindowFocusListeners = () => {
  if (windowFocusListenersActive) return
  window.addEventListener('focus', handleWindowFocus)
  window.addEventListener('blur', handleWindowBlur)
  windowFocusListenersActive = true
}

const detachWindowFocusListeners = () => {
  if (!windowFocusListenersActive) return
  window.removeEventListener('focus', handleWindowFocus)
  window.removeEventListener('blur', handleWindowBlur)
  windowFocusListenersActive = false
}

const systemModule: Module<ISystemState, IRootState> = {
  namespaced: true,
  state() {
    return {
      queryInfo: {},
      orderInfo: {},
      employeeList: [],
      employeeCount: 0,
      permissionList: [],
      permissionCount: 0,
      roleList: [],
      roleCount: 0,
      deptList: [],
      deptCount: 0,
      consumerList: [],
      consumerCount: 0,
      consumerRecordList: [],
      consumerRecordCount: 0,
      promotionMaterialList: [],
      promotionMaterialCount: 0,
      voiceList: [],
      voiceCount: 0,
      voiceDetailList: [],
      voiceDetailCount: 0,
      materialManageList: [],
      materialManageCount: 0,
      promotionAccessList: [],
      promotionAccessCount: 0,
      promotionAccessUvList: [],
      promotionAccessUvCount: 0,
      customerEventsList: [],
      customerEventsCount: 0,
      liveEventAccessList: [],
      liveEventAccessCount: 0,
      liveAccessStatisticsList: [],
      liveAccessStatisticsCount: 0,
      liveStatisticalDeptList: [],
      liveStatisticalDeptCount: 0,
      liveStatisticalContinueList: [],
      liveStatisticalContinueCount: 0,
      certificateList: [],
      certificateCount: 0,
      stockList: [],
      stockCount: 0,
      customerChannelList: [],
      customerChannelCount: 0,
      changeChannelStatisticsList: [],
      changeChannelStatisticsCount: 0,
      externalTeacherStatisticsList: [],
      externalTeacherStatisticsCount: 0,
      channelConfigList: [],
      channelConfigCount: 0,
      corpList: [],
      corpCount: 0,
      liveKeywordList: [],
      liveKeywordCount: 0,
      liveStatisticalEmpList: [],
      liveStatisticalEmpCount: 0,
      liveStatisticalEventList: [],
      liveStatisticalEventCount: 0,
      liveQuanziList: [],
      liveQuanziCount: 0,
      afterSalesLiveQuanziList: [],
      afterSalesLiveQuanziCount: 0,
      promotionStatisticalDeptList: [],
      promotionStatisticalDeptCount: 0,
      promotionStatisticalEmpList: [],
      promotionStatisticalEmpCount: 0,
      promotionStatisticalArticleList: [],
      promotionStatisticalArticleCount: 0,
      fuboTeacherList: [],
      fuboTeacherCount: 0,
      fuboCourseList: [],
      fuboCourseCount: 0,
      fuboVideoList: [],
      fuboVideoCount: 0,
      fuboAccessList: [],
      fuboAccessCount: 0,
      fuboAccessUvList: [],
      fuboAccessUvCount: 0,
      fuboStatisticalDeptList: [],
      fuboStatisticalDeptCount: 0,
      fuboStatisticalVideoList: [],
      fuboStatisticalVideoCount: 0,
      fuboStatisticalEmpList: [],
      fuboStatisticalEmpCount: 0,
      userExpandList: [],
      userExpandCount: 0,
      consumerStatisticalDeptList: [],
      consumerStatisticalDeptCount: 0,
      fundsVerificationList: [],
      fundsVerificationCount: 0,
      newFundsVerificationList: [],
      newFundsVerificationCount: 0,
      ledgerList: [],
      ledgerCount: 0,
      custCommPlanList: [],
      custCommPlanCount: 0,
      dailyCustList: [],
      dailyCustCount: 0,
      analyseStatisticsList: [],
      analyseStatisticsCount: 0,
      enterpriseWechatList: [],
      enterpriseWechatCount: 0,
      newCustList: [],
      newCustCount: 0,
      dictList: [],
      dictCount: 0,
      deductItemList: [],
      deductItemCount: 0,
      stockTagList: [],
      stockTagCount: 0,
      productList: [],
      productCount: 0,
      autoChatList: [],
      autoChatCount: 0,
      quickReplyList: [],
      quickReplyCount: 0,
      speechList: [],
      speechCount: 0,
      noticesList: [],
      noticesCount: 0,
      h5List: [],
      h5Count: 0,
      faqList: [],
      faqCount: 0,
      scrollPosition: 0,
      materialStatisticsList: [],
      materialStatisticsCount: 0,
      workPromotionManageList: [],
      workPromotionManageCount: 0,
      groupMsgReplyStatisticsList: [],
      groupMsgReplyStatisticsCount: 0,
      customReplyList: [],
      customReplyCount: 0,
      ybwaveList: [],
      ybwaveCount: 0,
      groupUsersList: [],
      groupUsersCount: 0,
      soMsgList: [],
      soMsgCount: 0,
      customDeletedList: [],
      customDeletedCount: 0,
      deletedCustomerList: [],
      deletedCustomerCount: 0,
      recentNotReplyList: [],
      recentNotReplyCount: 0,
      assignCustomersList: [],
      assignCustomersCount: 0,
      newResourceStatisticsList: [],
      newResourceStatisticsCount: 0,
      newResourceCallRateStatisticsList: [],
      newResourceCallRateStatisticsCount: 0,
      customClassifyStatisticsList: [],
      customClassifyStatisticsCount: 0,
      liveRetainedStatisticsList: [],
      liveRetainedStatisticsCount: 0,
      weChannelsList: [],
      weChannelsCount: 0,
      phoneStateList: [],
      phoneStateCount: 0,
      handOverList: [],
      handOverCount: 0,
      transferTipList: [],
      transferTipCount: 0,
      workerPointList: [],
      workerPointCount: 0,
      workloadCount: 0,
      workloadList: [],
      keyReplyCount: 0,
      keyReplyList: [],
      openOrClose: true,
      newCustomResourceCount: 0,
      newCustomResourceList: [],
      transferCustomerCount: 0,
      transferCustomerList: [],
      customerStatisticsCount: 0,
      customerStatisticsList: [],
      resourceQueryCount: 0,
      resourceQueryList: [],
      drainageStatisticsCount: 0,
      drainageStatisticsList: [],
      drainageResourceQueryCount: 0,
      drainageResourceQueryList: [],

      resourceTransformationCount: 0,
      resourceTransformationList: [],

      drawConfigCount: 0,
      drawConfigList: [],

      sensitiveWordsCount: 0,
      sensitiveWordsList: [],

      recordCallDetailsCount: 0,
      recordCallDetailsList: [],

      customerChannelStatisticsCount: 0,
      customerChannelStatisticsList: [],
      allChannelStatisticsCount: 0,
      allChannelStatisticsList: [],
      channelExceptionAddStatisticsCount: 0,
      channelExceptionAddStatisticsList: [],
      userSuccCount: 0,
      userSuccList: [],
      channelReportCount: 0,
      channelReportList: [],
      channelConversionStatisticsCount: 0,
      channelConversionStatisticsList: [],
      customResourceApplyCount: 0,
      customResourceApplyList: [],
      liveOnlineStatisticsCount: 0,
      liveOnlineStatisticsList: [],
      raffleManageCount: 0,
      raffleManageList: [],
      raffleRecordCount: 0,
      raffleRecordList: [],
      consumeBonusCount: 0,
      consumeBonusList: [],
      databaseConfigCount: 0,
      databaseConfigList: [],
      employeePointRecordCount: 0,
      employeePointRecordList: [],
      corpCustomerStatisticsCount: 0,
      corpCustomerStatisticsList: [],
      'enterpriseWechat/configList': [],
      'enterpriseWechat/configCount': 0,
      themeTableCount: 0,
      themeTableList: [],
      oprHistoryCount: 0,
      oprHistoryList: [],
      oprHistoryStatisticsCount: 0,
      oprHistoryStatisticsList: [],
      phoneResourceCount: 0,
      phoneResourceList: [],
      cfddCustomerChannelCount: 0,
      cfddCustomerChannelList: [],
      custGroupCount: 0,
      custGroupList: [],
      notAllowCustGroupCount: 0,
      notAllowCustGroupList: [],
      nextDayPhoneList: [],
      nextDayPhoneCount: 0,
      activateCustRecordList:[],
      activateCustRecordCount: 0,
      thirdPartyPhoneAccountConfigList:[],
      thirdPartyPhoneAccountConfigCount: 0,
      thirdPartyPhoneResourceStatisticsList: [],
      thirdPartyPhoneResourceStatisticsCount: 0,
      newResourcePhoneList: [],
      newResourcePhoneCount: 0,
      abnormalDataList: [],
      abnormalDataCount: 0,
      watchLiveNotDealList: [],
      watchLiveNotDealCount: 0,
      lowFrequencyLiveEmpList: [],
      lowFrequencyLiveEmpCount: 0,
      customerBasicInfoList: [],
      customerBasicInfoCount: 0,
      coreDataList: [],
      coreDataCount: 0,

      welcomeList: [],
      welcomeCount: 0,

      oaList: [],
      oaCount: 0,

      mpList: [],
      mpCount: 0,

      shServiceList: [],
      shServiceCount: 0,

      webSocket: null as WebSocket | null
    }
  },
  mutations: {
    changeOpenOrClose(state, openOrClose) {
      state.openOrClose = openOrClose
    },
    changeQueyryInfo(state, queryInfo: any) {
      state.queryInfo = queryInfo
    },
    changeOrderInfo(state, orderInfo: any) {
      state.orderInfo = orderInfo
    },
    changeEmployeeList(state, employeeList: any[]) {
      state.employeeList = employeeList
    },
    changeEmployeeCount(state, employeeCount: number) {
      state.employeeCount = employeeCount
    },
    changePermissionList(state, permissionList: any[]) {
      state.permissionList = permissionList
    },
    changePermissionCount(state, permissionCount: number) {
      state.permissionCount = permissionCount
    },
    changeRoleList(state, roleList: any[]) {
      state.roleList = roleList
    },
    changeRoleCount(state, roleCount: number) {
      state.roleCount = roleCount
    },
    changeDeptList(state, deptList: any[]) {
      state.deptList = deptList
    },
    changeDeptCount(state, deptCount: number) {
      state.deptCount = deptCount
    },
    changeConsumerList(state, consumerList: any[]) {
      state.consumerList = consumerList
    },
    changeConsumerCount(state, consumerCount: number) {
      state.consumerCount = consumerCount
    },
    changeConsumerRecordList(state, consumerRecordList: any[]) {
      state.consumerRecordList = consumerRecordList
    },
    changeConsumerRecordCount(state, consumerRecordCount: number) {
      state.consumerRecordCount = consumerRecordCount
    },
    changePromotionMaterialList(state, promotionMaterialList: any[]) {
      state.promotionMaterialList = promotionMaterialList
    },
    changePromotionMaterialCount(state, promotionMaterialCount: number) {
      state.promotionMaterialCount = promotionMaterialCount
    },
    changeVoiceList(state, voiceList: any[]) {
      state.voiceList = voiceList
    },
    changeVoiceCount(state, voiceCount: number) {
      state.voiceCount = voiceCount
    },
    changeVoiceDetailList(state, voiceDetailList: any[]) {
      state.voiceDetailList = voiceDetailList
    },
    changeVoiceDetailCount(state, voiceDetailCount: number) {
      state.voiceDetailCount = voiceDetailCount
    },
    changeMaterialManageList(state, materialManageList: any[]) {
      state.materialManageList = materialManageList
    },
    changeMaterialManageCount(state, materialManageCount: number) {
      state.materialManageCount = materialManageCount
    },
    changePromotionAccessList(state, promotionAccessList: any[]) {
      state.promotionAccessList = promotionAccessList
    },
    changePromotionAccessCount(state, promotionAccessCount: number) {
      state.promotionAccessCount = promotionAccessCount
    },
    changePromotionAccessUvList(state, promotionAccessUvList: any[]) {
      state.promotionAccessUvList = promotionAccessUvList
    },
    changePromotionAccessUvCount(state, promotionAccessUvCount: number) {
      state.promotionAccessUvCount = promotionAccessUvCount
    },
    changePromotionStatisticalDeptList(
      state,
      promotionStatisticalDeptList: any[]
    ) {
      state.promotionStatisticalDeptList = promotionStatisticalDeptList
    },
    changePromotionStatisticalDeptCount(
      state,
      promotionStatisticalDeptCount: number
    ) {
      state.promotionStatisticalDeptCount = promotionStatisticalDeptCount
    },
    changePromotionStatisticalEmpList(
      state,
      promotionStatisticalEmpList: any[]
    ) {
      state.promotionStatisticalEmpList = promotionStatisticalEmpList
    },
    changePromotionStatisticalEmpCount(
      state,
      promotionStatisticalEmpCount: number
    ) {
      state.promotionStatisticalEmpCount = promotionStatisticalEmpCount
    },
    changePromotionStatisticalArticleList(
      state,
      promotionStatisticalArticleList: any[]
    ) {
      state.promotionStatisticalArticleList = promotionStatisticalArticleList
    },
    changePromotionStatisticalArticleCount(
      state,
      promotionStatisticalArticleCount: number
    ) {
      state.promotionStatisticalArticleCount = promotionStatisticalArticleCount
    },
    changeCustomerEventsList(state, customerEventsList: any[]) {
      state.customerEventsList = customerEventsList
    },
    changeCustomerEventsCount(state, customerEventsCount: number) {
      state.customerEventsCount = customerEventsCount
    },
    changeLiveEventAccessList(state, liveEventAccessList: any[]) {
      state.liveEventAccessList = liveEventAccessList
    },
    changeLiveEventAccessCount(state, liveEventAccessCount: number) {
      state.liveEventAccessCount = liveEventAccessCount
    },
    changeLiveAccessStatisticsList(state, liveAccessStatisticsList: any[]) {
      state.liveAccessStatisticsList = liveAccessStatisticsList
    },
    changeLiveAccessStatisticsCount(state, liveAccessStatisticsCount: number) {
      state.liveAccessStatisticsCount = liveAccessStatisticsCount
    },
    changeLiveStatisticalDeptList(state, liveStatisticalDeptList: any[]) {
      state.liveStatisticalDeptList = liveStatisticalDeptList
    },
    changeLiveStatisticalDeptCount(state, liveStatisticalDeptCount: number) {
      state.liveStatisticalDeptCount = liveStatisticalDeptCount
    },
    changeLiveStatisticalContinueList(
      state,
      liveStatisticalContinueList: any[]
    ) {
      state.liveStatisticalContinueList = liveStatisticalContinueList
    },
    changeLiveStatisticalContinueCount(
      state,
      liveStatisticalContinueCount: number
    ) {
      state.liveStatisticalContinueCount = liveStatisticalContinueCount
    },
    changeCertificateList(state, certificateList: any[]) {
      state.certificateList = certificateList
    },
    changeCertificateCount(state, certificateCount: number) {
      state.certificateCount = certificateCount
    },
    changeStockList(state, stockList: any[]) {
      state.stockList = stockList
    },
    changeStockCount(state, stockCount: number) {
      state.stockCount = stockCount
    },
    changeCustomerChannelList(state, customerChannelList: any[]) {
      state.customerChannelList = customerChannelList
    },
    changeCustomerChannelCount(state, customerChannelCount: number) {
      state.customerChannelCount = customerChannelCount
    },
    changeChangeChannelStatisticsList(
      state,
      changeChannelStatisticsList: any[]
    ) {
      state.changeChannelStatisticsList = changeChannelStatisticsList
    },
    changeChangeChannelStatisticsCount(
      state,
      changeChannelStatisticsCount: number
    ) {
      state.changeChannelStatisticsCount = changeChannelStatisticsCount
    },
    changeExternalTeacherStatisticsList(
      state,
      externalTeacherStatisticsList: any[]
    ) {
      state.externalTeacherStatisticsList = externalTeacherStatisticsList
    },
    changeExternalTeacherStatisticsCount(
      state,
      externalTeacherStatisticsCount: number
    ) {
      state.externalTeacherStatisticsCount = externalTeacherStatisticsCount
    },
    changeChannelConfigList(state, channelConfigList: any[]) {
      state.channelConfigList = channelConfigList
    },
    changeChannelConfigCount(state, channelConfigCount: number) {
      state.channelConfigCount = channelConfigCount
    },
    changeCorpList(state, corpList: any[]) {
      state.corpList = corpList
    },
    changeCorpCount(state, corpCount: number) {
      state.corpCount = corpCount
    },
    changeLiveKeywordList(state, liveKeywordList: any[]) {
      state.liveKeywordList = liveKeywordList
    },
    changeLiveKeywordCount(state, liveKeywordCount: number) {
      state.liveKeywordCount = liveKeywordCount
    },
    changeLiveStatisticalEmpList(state, liveStatisticalEmpList: any[]) {
      state.liveStatisticalEmpList = liveStatisticalEmpList
    },
    changeLiveStatisticalEmpCount(state, liveStatisticalEmpCount: number) {
      state.liveStatisticalEmpCount = liveStatisticalEmpCount
    },
    changeLiveStatisticalEventList(state, liveStatisticalEventList: any[]) {
      state.liveStatisticalEventList = liveStatisticalEventList
    },
    changeLiveStatisticalEventCount(state, liveStatisticalEventCount: number) {
      state.liveStatisticalEventCount = liveStatisticalEventCount
    },
    changeLiveQuanziList(state, liveQuanziList: any[]) {
      state.liveQuanziList = liveQuanziList
    },
    changeLiveQuanziCount(state, liveQuanziCount: number) {
      state.liveQuanziCount = liveQuanziCount
    },
    changeAfterSalesLiveQuanziList(state, afterSalesLiveQuanziList: any[]) {
      state.afterSalesLiveQuanziList = afterSalesLiveQuanziList
    },
    changeAfterSalesLiveQuanziCount(state, afterSalesLiveQuanziCount: number) {
      state.afterSalesLiveQuanziCount = afterSalesLiveQuanziCount
    },
    changeFuboTeacherList(state, fuboTeacherList: any[]) {
      state.fuboTeacherList = fuboTeacherList
    },
    changeFuboTeacherCount(state, fuboTeacherCount: number) {
      state.fuboTeacherCount = fuboTeacherCount
    },
    changeFuboCourseList(state, fuboCourseList: any[]) {
      state.fuboCourseList = fuboCourseList
    },
    changeFuboCourseCount(state, fuboCourseCount: number) {
      state.fuboCourseCount = fuboCourseCount
    },
    changeFuboVideoList(state, fuboVideoList: any[]) {
      state.fuboVideoList = fuboVideoList
    },
    changeFuboVideoCount(state, fuboVideoCount: number) {
      state.fuboVideoCount = fuboVideoCount
    },
    changeFuboAccessList(state, fuboAccessList: any[]) {
      state.fuboAccessList = fuboAccessList
    },
    changeFuboAccessCount(state, fuboAccessCount: number) {
      state.fuboAccessCount = fuboAccessCount
    },
    changeFuboAccessUvList(state, fuboAccessUvList: any[]) {
      state.fuboAccessUvList = fuboAccessUvList
    },
    changeFuboAccessUvCount(state, fuboAccessUvCount: number) {
      state.fuboAccessUvCount = fuboAccessUvCount
    },
    changeFuboStatisticalDeptList(state, fuboStatisticalDeptList: any[]) {
      state.fuboStatisticalDeptList = fuboStatisticalDeptList
    },
    changeFuboStatisticalDeptCount(state, fuboStatisticalDeptCount: number) {
      state.fuboStatisticalDeptCount = fuboStatisticalDeptCount
    },
    changeFuboStatisticalVideoList(state, fuboStatisticalVideoList: any[]) {
      state.fuboStatisticalVideoList = fuboStatisticalVideoList
    },
    changeFuboStatisticalVideoCount(state, fuboStatisticalVideoCount: number) {
      state.fuboStatisticalVideoCount = fuboStatisticalVideoCount
    },
    changeFuboStatisticalEmpList(state, fuboStatisticalEmpList: any[]) {
      state.fuboStatisticalEmpList = fuboStatisticalEmpList
    },
    changeFuboStatisticalEmpCount(state, fuboStatisticalEmpCount: number) {
      state.fuboStatisticalEmpCount = fuboStatisticalEmpCount
    },
    changeUserExpandList(state, userExpandList: any[]) {
      state.userExpandList = userExpandList
    },
    changeUserExpandCount(state, userExpandCount: number) {
      state.userExpandCount = userExpandCount
    },
    changeConsumerStatisticalDeptList(
      state,
      consumerStatisticalDeptList: any[]
    ) {
      state.consumerStatisticalDeptList = consumerStatisticalDeptList
    },
    changeConsumerStatisticalDeptCount(
      state,
      consumerStatisticalDeptCount: number
    ) {
      state.consumerStatisticalDeptCount = consumerStatisticalDeptCount
    },
    changeFundsVerificationList(state, fundsVerificationList: any[]) {
      state.fundsVerificationList = fundsVerificationList
    },
    changeFundsVerificationCount(state, fundsVerificationCount: number) {
      state.fundsVerificationCount = fundsVerificationCount
    },
    changeNewFundsVerificationList(state, newFundsVerificationList: any[]) {
      state.newFundsVerificationList = newFundsVerificationList
    },
    changeNewFundsVerificationCount(state, newFundsVerificationCount: number) {
      state.newFundsVerificationCount = newFundsVerificationCount
    },
    changeLedgerList(state, ledgerList: any[]) {
      state.ledgerList = ledgerList
    },
    changeLedgerCount(state, ledgerCount: number) {
      state.ledgerCount = ledgerCount
    },
    changeCustCommPlanList(state, custCommPlanList: any[]) {
      state.custCommPlanList = custCommPlanList
    },
    changeCustCommPlanCount(state, custCommPlanCount: number) {
      state.custCommPlanCount = custCommPlanCount
    },
    changeDailyCustList(state, dailyCustList: any[]) {
      state.dailyCustList = dailyCustList
    },
    changeDailyCustCount(state, dailyCustCount: number) {
      state.dailyCustCount = dailyCustCount
    },
    changeAnalyseStatisticsList(state, analyseStatisticsList: any[]) {
      state.analyseStatisticsList = analyseStatisticsList
    },
    changeAnalyseStatisticsCount(state, analyseStatisticsCount: number) {
      state.analyseStatisticsCount = analyseStatisticsCount
    },
    changeEnterpriseWechatList(state, enterpriseWechatList: any[]) {
      state.enterpriseWechatList = enterpriseWechatList
    },
    changeEnterpriseWechatCount(state, enterpriseWechatCount: number) {
      state.enterpriseWechatCount = enterpriseWechatCount
    },
    changeNewCustList(state, newCustList: any[]) {
      state.newCustList = newCustList
    },
    changeNewCustCount(state, newCustCount: number) {
      state.newCustCount = newCustCount
    },
    changeDictList(state, dictList: any[]) {
      state.dictList = dictList
    },
    changeDictCount(state, dictCount: number) {
      state.dictCount = dictCount
    },
    changeDeductItemList(state, deductItemList: any[]) {
      state.deductItemList = deductItemList
    },
    changeDeductItemCount(state, deductItemCount: number) {
      state.deductItemCount = deductItemCount
    },
    changeStockTagList(state, stockTagList: any[]) {
      state.stockTagList = stockTagList
    },
    changeStockTagCount(state, stockTagCount: number) {
      state.stockTagCount = stockTagCount
    },
    changeProductList(state, productList: any[]) {
      state.productList = productList
    },
    changeProductCount(state, productCount: number) {
      state.productCount = productCount
    },
    changeAutoChatList(state,autoChatList: any[]) {
      state.autoChatList = autoChatList
    },
    changeAutoChatCount(state,autoChatCount: number) {
      state.autoChatCount = autoChatCount
    },
    changeQuickReplyList(state, quickReplyList: any[]) {
      state.quickReplyList = quickReplyList
    },
    changeQuickReplyCount(state, quickReplyCount: number) {
      state.quickReplyCount = quickReplyCount
    },
    changeSpeechCount(state, speechCount: number) {
      state.speechCount = speechCount
    },
    changeSpeechList(state, speechList: any[]) {
      state.speechList = speechList
    },
    changeNoticesCount(state, noticesCount: number) {
      state.noticesCount = noticesCount
    },
    changeNoticesList(state, noticesList: any[]) {
      state.noticesList = noticesList
    },
    changeH5List(state, h5List: any[]) {
      state.h5List = h5List
    },
    changeH5Count(state, h5Count: number) {
      state.h5Count = h5Count
    },
    changeFaqList(state, faqList: any[]) {
      state.faqList = faqList
    },
    changeFaqCount(state, faqCount: number) {
      state.faqCount = faqCount
    },
    updateScrollPosition(state, position: number) {
      state.scrollPosition = position
    },
    changeMaterialStatisticsList(state, materialStatisticsList: any[]) {
      state.materialStatisticsList = materialStatisticsList
    },
    changeMaterialStatisticsCount(state, materialStatisticsCount: number) {
      state.materialStatisticsCount = materialStatisticsCount
    },
    changeWorkPromotionManageList(state, workPromotionManageList: any[]) {
      state.workPromotionManageList = workPromotionManageList
    },
    changeWorkPromotionManageCount(state, workPromotionManageCount: number) {
      state.workPromotionManageCount = workPromotionManageCount
    },
    changeGroupMsgReplyStatisticsList(
      state,
      groupMsgReplyStatisticsList: any[]
    ) {
      state.groupMsgReplyStatisticsList = groupMsgReplyStatisticsList
    },
    changeGroupMsgReplyStatisticsCount(
      state,
      groupMsgReplyStatisticsCount: number
    ) {
      state.groupMsgReplyStatisticsCount = groupMsgReplyStatisticsCount
    },
    changeCustomReplyList(state, customReplyList: any[]) {
      state.customReplyList = customReplyList
    },
    changeCustomReplyCount(state, customReplyCount: number) {
      state.customReplyCount = customReplyCount
    },
    changeCustomDeletedList(state, customDeletedList: any[]) {
      state.customDeletedList = customDeletedList
    },
    changeCustomDeletedCount(state, customDeletedCount: number) {
      state.customDeletedCount = customDeletedCount
    },
    changeDeletedCustomerList(state, deletedCustomerList: any[]) {
      state.deletedCustomerList = deletedCustomerList
    },
    changeDeletedCustomerCount(state, deletedCustomerCount: number) {
      state.deletedCustomerCount = deletedCustomerCount
    },
    changeNewResourceStatisticsList(state, newResourceStatisticsList: any[]) {
      state.newResourceStatisticsList = newResourceStatisticsList
    },
    changeNewResourceStatisticsCount(
      state,
      newResourceStatisticsCount: number
    ) {
      state.newResourceStatisticsCount = newResourceStatisticsCount
    },
    changeNewResourceCallRateStatisticsList(
      state,
      newResourceCallRateStatisticsList: any[]
    ) {
      state.newResourceCallRateStatisticsList =
        newResourceCallRateStatisticsList
    },
    changeNewResourceCallRateStatisticsCount(
      state,
      newResourceCallRateStatisticsCount: number
    ) {
      state.newResourceCallRateStatisticsCount =
        newResourceCallRateStatisticsCount
    },
    changeWeChannelsList(
      state,
      weChannelsList: any[]
    ) {
      state.weChannelsList =
        weChannelsList
    },
    changeWeChannelsCount(
      state,
      weChannelsCount: number
    ) {
      state.weChannelsCount =
        weChannelsCount
    },
    changeCustomClassifyStatisticsList(
      state,
      customClassifyStatisticsList: any[]
    ) {
      state.customClassifyStatisticsList = customClassifyStatisticsList
    },
    changeCustomClassifyStatisticsCount(
      state,
      customClassifyStatisticsCount: number
    ) {
      state.customClassifyStatisticsCount = customClassifyStatisticsCount
    },
    changeLiveRetainedStatisticsList(state, liveRetainedStatisticsList: any[]) {
      state.liveRetainedStatisticsList = liveRetainedStatisticsList
    },
    changeLiveRetainedStatisticsCount(
      state,
      liveRetainedStatisticsCount: number
    ) {
      state.liveRetainedStatisticsCount = liveRetainedStatisticsCount
    },
    changeRecentNotReplyList(state, recentNotReplyList: any[]) {
      state.recentNotReplyList = recentNotReplyList
    },
    changeRecentNotReplyCount(state, recentNotReplyCount: number) {
      state.recentNotReplyCount = recentNotReplyCount
    },
    changeAssignCustomersList(state, assignCustomersList: any[]) {
      state.assignCustomersList = assignCustomersList
    },
    changeAssignCustomersCount(state, assignCustomersCount: number) {
      state.assignCustomersCount = assignCustomersCount
    },
    changePhoneStateList(state, phoneStateList: any[]) {
      state.phoneStateList = phoneStateList
    },
    changePhoneStateCount(state, phoneStateCount: number) {
      state.phoneStateCount = phoneStateCount
    },
    changeYbwaveList(state, ybwaveList: any[]) {
      state.ybwaveList = ybwaveList
    },
    changeYbwaveCount(state, ybwaveCount: number) {
      state.ybwaveCount = ybwaveCount
    },
    changeGroupUsersList(state, groupUsersList: any[]) {
      state.groupUsersList = groupUsersList
    },
    changeGroupUsersCount(state, groupUsersCount: number) {
      state.groupUsersCount = groupUsersCount
    },
    changeSoMsgList(state, soMsgList: any[]) {
      state.soMsgList = soMsgList
    },
    changeSoMsgCount(state, soMsgCount: number) {
      state.soMsgCount = soMsgCount
    },
    changeHandOverList(state, handOverList: any[]) {
      state.handOverList = handOverList
    },
    changeHandOverCount(state, handOverCount: number) {
      state.handOverCount = handOverCount
    },
    changeTransferTipList(state, transferTipList: any[]) {
      state.transferTipList = transferTipList
    },
    changeTransferTipCount(state, transferTipCount: number) {
      state.transferTipCount = transferTipCount
    },
    changeWorkerPointList(state, workerPointList: any[]) {
      state.workerPointList = workerPointList
    },
    changeWorkerPointCount(state, workerPointCount: number) {
      state.workerPointCount = workerPointCount
    },
    changeWorkloadList(state, workloadList: any[]) {
      state.workloadList = workloadList
    },
    changeWorkloadCount(state, workloadCount: number) {
      state.workloadCount = workloadCount
    },
    changeKeyReplyList(state, keyReplyList: any[]) {
      state.keyReplyList = keyReplyList
    },
    changeKeyReplyCount(state, keyReplyCount: number) {
      state.keyReplyCount = keyReplyCount
    },
    changeNewCustomResourceList(state, newCustomResourceList: any[]) {
      state.newCustomResourceList = newCustomResourceList
    },
    changeNewCustomResourceCount(state, newCustomResourceCount: number) {
      state.newCustomResourceCount = newCustomResourceCount
    },
    changeCustomResourceApplyCount(state, customResourceApplyCount: number) {
      state.customResourceApplyCount = customResourceApplyCount
    },
    changeCustomResourceApplyList(state, customResourceApplyList: any[]) {
      state.customResourceApplyList = customResourceApplyList
    },
    changeTransferCustomerList(state, transferCustomerList: any[]) {
      state.transferCustomerList = transferCustomerList
    },
    changeTransferCustomerCount(state, transferCustomerCount: number) {
      state.transferCustomerCount = transferCustomerCount
    },
    changeCustomerStatisticsList(state, customerStatisticsList: any[]) {
      state.customerStatisticsList = customerStatisticsList
    },
    changeCustomerStatisticsCount(state, customerStatisticsCount: number) {
      state.customerStatisticsCount = customerStatisticsCount
    },

    changeResourceQueryList(state, resourceQueryList: any[]) {
      state.resourceQueryList = resourceQueryList
    },
    changeResourceQueryCount(state, resourceQueryCount: number) {
      state.resourceQueryCount = resourceQueryCount
    },

    changeDrainageStatisticsList(state, drainageStatisticsList: any[]) {
      state.drainageStatisticsList = drainageStatisticsList
    },
    changeDrainageStatisticsCount(state, drainageStatisticsCount: number) {
      state.drainageStatisticsCount = drainageStatisticsCount
    },

    changeDrainageResourceQueryList(state, drainageResourceQueryList: any) {
      state.drainageResourceQueryList = drainageResourceQueryList
    },
    changeDrainageResourceQueryCount(
      state,
      drainageResourceQueryCount: number
    ) {
      state.drainageResourceQueryCount = drainageResourceQueryCount
    },

    changeResourceTransformationCount(
      state,
      resourceTransformationCount: number
    ) {
      state.resourceTransformationCount = resourceTransformationCount
    },
    changeResourceTransformationList(state, resourceTransformationList: any) {
      state.resourceTransformationList = resourceTransformationList
    },

    changeDrawConfigCount(state, drawConfigCount: number) {
      state.drawConfigCount = drawConfigCount
    },
    changeDrawConfigList(state, drawConfigList: any) {
      state.drawConfigList = drawConfigList
    },

    changeSensitiveWordsCount(state, sensitiveWordsCount: number) {
      state.sensitiveWordsCount = sensitiveWordsCount
    },
    changeSensitiveWordsList(state, sensitiveWordsList: any) {
      state.sensitiveWordsList = sensitiveWordsList
    },
    changeRecordCallDetailsCount(state, recordCallDetailsCount: number) {
      state.recordCallDetailsCount = recordCallDetailsCount
    },
    changeRecordCallDetailsList(state, recordCallDetailsList: any) {
      state.recordCallDetailsList = recordCallDetailsList
    },

    changeCustomerChannelStatisticsList(
      state,
      customerChannelStatisticsList: any[]
    ) {
      state.customerChannelStatisticsList = customerChannelStatisticsList
    },
    changeCustomerChannelStatisticsCount(
      state,
      customerChannelStatisticsCount: number
    ) {
      state.customerChannelStatisticsCount = customerChannelStatisticsCount
    },

    changeAllChannelStatisticsList(state, allChannelStatisticsList: any[]) {
      state.allChannelStatisticsList = allChannelStatisticsList
    },
    changeAllChannelStatisticsCount(state, allChannelStatisticsCount: number) {
      state.allChannelStatisticsCount = allChannelStatisticsCount
    },

    changeChannelExceptionAddStatisticsList(
      state,
      channelExceptionAddStatisticsList: any[]
    ) {
      state.channelExceptionAddStatisticsList =
        channelExceptionAddStatisticsList
    },
    changeChannelExceptionAddStatisticsCount(
      state,
      channelExceptionAddStatisticsCount: number
    ) {
      state.channelExceptionAddStatisticsCount =
        channelExceptionAddStatisticsCount
    },

    changeUserSuccList(state, userSuccList: any[]) {
      state.userSuccList = userSuccList
    },
    changeUserSuccCount(state, userSuccCount: number) {
      state.userSuccCount = userSuccCount
    },

    changeChannelReportList(state, channelReportList: any[]) {
      state.channelReportList = channelReportList
    },
    changeChannelReportCount(state, channelReportCount: number) {
      state.channelReportCount = channelReportCount
    },

    changeChannelConversionStatisticsList(
      state,
      channelConversionStatisticsList: any[]
    ) {
      state.channelConversionStatisticsList = channelConversionStatisticsList
    },
    changeChannelConversionStatisticsCount(
      state,
      channelConversionStatisticsCount: number
    ) {
      state.channelConversionStatisticsCount = channelConversionStatisticsCount
    },

    changeLiveOnlineStatisticsList(state, liveOnlineStatisticsList: any[]) {
      state.liveOnlineStatisticsList = liveOnlineStatisticsList
    },
    changeLiveOnlineStatisticsCount(state, liveOnlineStatisticsCount: number) {
      state.liveOnlineStatisticsCount = liveOnlineStatisticsCount
    },
    changeRaffleManageList(state, raffleManageList: any[]) {
      state.raffleManageList = raffleManageList
    },
    changeRaffleManageCount(state, raffleManageCount: number) {
      state.raffleManageCount = raffleManageCount
    },
    changeRaffleRecordList(state, raffleRecordList: any[]) {
      state.raffleRecordList = raffleRecordList
    },
    changeRaffleRecordCount(state, raffleRecordCount: number) {
      state.raffleRecordCount = raffleRecordCount
    },
    changeConsumeBonusList(state, consumeBonusList: any[]) {
      state.consumeBonusList = consumeBonusList
    },
    changeConsumeBonusCount(state, consumeBonusCount: number) {
      state.consumeBonusCount = consumeBonusCount
    },
    changeDatabaseConfigList(state, databaseConfigList: any[]) {
      state.databaseConfigList = databaseConfigList
    },
    changeDatabaseConfigCount(state, databaseConfigCount: number) {
      state.databaseConfigCount = databaseConfigCount
    },
    changeEmployeePointRecordList(state, employeePointRecordList: any[]) {
      state.employeePointRecordList = employeePointRecordList
    },
    changeEmployeePointRecordCount(state, employeePointRecordCount: number) {
      state.employeePointRecordCount = employeePointRecordCount
    },
    changeOprHistoryList(state, oprHistoryList: any[]) {
      state.oprHistoryList = oprHistoryList
    },
    changeOprHistoryCount(state, oprHistoryCount: number) {
      state.oprHistoryCount = oprHistoryCount
    },
    changeOprHistoryStatisticsList(state, oprHistoryStatisticsList: any[]) {
      state.oprHistoryStatisticsList = oprHistoryStatisticsList
    },
    changeOprHistoryStatisticsCount(state, oprHistoryStatisticsCount: number) {
      state.oprHistoryStatisticsCount = oprHistoryStatisticsCount
    },
    changeCorpCustomerStatisticsList(state, corpCustomerStatisticsList: any[]) {
      state.corpCustomerStatisticsList = corpCustomerStatisticsList
    },
    changeCorpCustomerStatisticsCount(
      state,
      corpCustomerStatisticsCount: number
    ) {
      state.corpCustomerStatisticsCount = corpCustomerStatisticsCount
    },
    'changeEnterpriseWechat/configList'(state, configList: any[]) {
      state['enterpriseWechat/configList'] = configList
    },
    'changeEnterpriseWechat/configCount'(state, configCount: number) {
      state['enterpriseWechat/configCount'] = configCount
    },
    changeThemeTableList(state, themeTableList: any[]) {
      state.themeTableList = themeTableList
    },
    changeThemeTableCount(state, themeTableCount: number) {
      state.themeTableCount = themeTableCount
    },
    changePhoneResourceCount(state, phoneResourceCount: number) {
      state.phoneResourceCount = phoneResourceCount
    },
    changePhoneResourceList(state, phoneResourceList: any) {
      state.phoneResourceList = phoneResourceList
    },
    changeCfddCustomerChannelCount(state, cfddCustomerChannelCount: number) {
      state.cfddCustomerChannelCount = cfddCustomerChannelCount
    },
    changeCfddCustomerChannelList(state, cfddCustomerChannelList: any) {
      state.cfddCustomerChannelList = cfddCustomerChannelList
    },
    changeCustGroupCount(state, custGroupCount: number) {
      state.custGroupCount = custGroupCount
    },
    changeCustGroupList(state, custGroupList: any) {
      state.custGroupList = custGroupList
    },
    changeNotAllowCustGroupCount(state, notAllowCustGroupCount: number) {
      state.notAllowCustGroupCount = notAllowCustGroupCount
    },
    changeNotAllowCustGroupList(state, notAllowCustGroupList: any) {
      state.notAllowCustGroupList = notAllowCustGroupList
    },
    changeNextDayPhoneCount(state, nextDayPhoneCount: number) {
      state.nextDayPhoneCount = nextDayPhoneCount
    },
    changeNextDayPhoneList(state, nextDayPhoneList: any) {
      state.nextDayPhoneList = nextDayPhoneList
    },
    changeActivateCustRecordCount(state, activateCustRecordCount: number) {
      state.activateCustRecordCount = activateCustRecordCount
    },
    changeActivateCustRecordList(state, activateCustRecordList: any) {
      state.activateCustRecordList = activateCustRecordList
    },
    changeThirdPartyPhoneAccountConfigCount(state, thirdPartyPhoneAccountConfigCount: number) {
      state.thirdPartyPhoneAccountConfigCount = thirdPartyPhoneAccountConfigCount
    },
    changeThirdPartyPhoneAccountConfigList(state, thirdPartyPhoneAccountConfigList: any) {
      state.thirdPartyPhoneAccountConfigList = thirdPartyPhoneAccountConfigList
    },
    changeThirdPartyPhoneResourceStatisticsCount(state, thirdPartyPhoneResourceStatisticsCount: number) {
      state.thirdPartyPhoneResourceStatisticsCount = thirdPartyPhoneResourceStatisticsCount
    },
    changeThirdPartyPhoneResourceStatisticsList(state, thirdPartyPhoneResourceStatisticsList: any) {
      state.thirdPartyPhoneResourceStatisticsList = thirdPartyPhoneResourceStatisticsList
    },
    changeNewResourcePhoneCount(state, newResourcePhoneCount: number) {
      state.newResourcePhoneCount = newResourcePhoneCount
    },
    changeNewResourcePhoneList(state, newResourcePhoneList: any) {
      state.newResourcePhoneList = newResourcePhoneList
    },
    changeAbnormalDataCount(state, abnormalDataCount: number) {
      state.abnormalDataCount = abnormalDataCount
    },
    changeAbnormalDataList(state, abnormalDataList: any) {
      state.abnormalDataList = abnormalDataList
    },
    changeWatchLiveNotDealCount(state, watchLiveNotDealCount: number) {
      state.watchLiveNotDealCount = watchLiveNotDealCount
    },
    changeWatchLiveNotDealList(state, watchLiveNotDealList: any) {
      state.watchLiveNotDealList = watchLiveNotDealList
    },
    changeLowFrequencyLiveEmpCount(state, lowFrequencyLiveEmpCount: number) {
      state.lowFrequencyLiveEmpCount = lowFrequencyLiveEmpCount
    },
    changeLowFrequencyLiveEmpList(state, lowFrequencyLiveEmpList: any) {
      state.lowFrequencyLiveEmpList = lowFrequencyLiveEmpList
    },
    changeCustomerBasicInfoList(state, customerBasicInfoList: any) {
      state.customerBasicInfoList = customerBasicInfoList
    },
    changeCustomerBasicInfoCount(state, customerBasicInfoCount: number) {
      state.customerBasicInfoCount = customerBasicInfoCount
    },
    changeWelcomeList(state, welcomeList: any) {
      state.welcomeList = welcomeList
    },
    changeWelcomeCount(state, welcomeCount: number) {
      state.welcomeCount = welcomeCount
    },
    changeOaList(state, oaList: any) {
      state.oaList = oaList
    },
    changeOaCount(state, oaCount) {
      state.oaCount = oaCount
    },
    changeMpList(state, mpList: any) {
      state.mpList = mpList
    },
    changeMpCount(state, mpCount) {
      state.mpCount = mpCount
    },

    changeShServiceList(state, shServiceList: any[]) {
      state.shServiceList = shServiceList
    },
    changeShServiceCount(state, shServiceCount: number) {
      state.shServiceCount = shServiceCount
    },

    changeCoreDataList(state, coreDataList: any[]) {
      state.coreDataList = coreDataList
    },
    changeCoreDataCount(state, coreDataCount: number) {
      state.coreDataCount = coreDataCount
    },

    /**
     * 清理列表数据 - 用于释放内存，防止长时间运行后数据累积
     * @param keepList 需要保留的列表名称数组（不包含 'List' 后缀）
     */
    clearListData(state, keepList: string[] = []) {
      // 动态获取所有以 'List' 结尾且值为数组的字段
      const listFields = Object.keys(state).filter(
        (key) =>
          key.endsWith('List') &&
          Array.isArray((state as any)[key]) &&
          !keepList.some((keep) => `${keep}List` === key)
      )

      listFields.forEach((listKey) => {
        const countKey = listKey.replace('List', 'Count');
        (state as any)[listKey] = []
        if ((state as any)[countKey] !== undefined) {
          ;(state as any)[countKey] = 0
        }
      })
    },
    setWebSocket(state, webSocket: WebSocket | null) {
      state.webSocket = webSocket
    }
  },
  getters: {
    pageListData: (state) => (pageName: string) => {
      return (state as any)[`${pageName}List`]
    },
    pageCountData: (state) => (pageName: string) => {
      return (state as any)[`${pageName}Count`]
    }
  },
  actions: {
    setScrollPosition({ commit }: { commit: any }, position: number) {
      commit('updateScrollPosition', position)
    },
    async getPageListAction({ commit, state }, payload: any) {
      const pageName = payload.pageName as string
      let url = `/main/${pageName}/queryByCondition`
      if(payload.pageUrl){
        url = payload.pageUrl
      }
      const data = await getPageListData(url, {
        ...payload.queryInfo,
        ...state.orderInfo
      })
      const changedPageName =
        pageName.charAt(0).toUpperCase() + pageName.slice(1)
      commit(`change${changedPageName}List`, data.list ?data.list : data.records)
      commit(`change${changedPageName}Count`, Number(data.total))
    },
    async getPostPageListAction({ commit, state }, payload: any) {
      const pageName = payload.pageName as string
      let url = `/main/${pageName}/queryByCondition`
      if(payload.pageUrl){
        url = payload.pageUrl
      }
      const data = await getPostPageListData(url, {
        ...payload.queryInfo,
        ...state.orderInfo
      })
      const changedPageName =
        pageName.charAt(0).toUpperCase() + pageName.slice(1)
      commit(`change${changedPageName}List`, data.list ? data.list : data.records)
      commit(`change${changedPageName}Count`, Number(data.total))
    },
    async deletePageDataAction({ dispatch, state }, payload: any) {
      let url = `/main/${payload.pageName}/${payload.id}`
      if(payload.delUrl){
        url = `${payload.delUrl}/${payload.id}`
      }
      await deletePageData(url)
      ElMessage({
        type: 'success',
        message: '删除成功'
      })
      dispatch('getPageListAction', {
        pageName: payload.pageName,
        queryInfo: state.queryInfo,
        pageUrl: payload?.pageUrl
      })
    },

    async exportXlsxAction({ commit, state }, payload: any) {
      const pageName = payload.pageName as string
      let url = `/main/${pageName}/download`
      if(payload.downUrl){
        url = payload.downUrl
      }
      const loadingInstance = ElLoading.service({
        lock: true,
        text: '数据下载中...',
        background: 'rgba(0, 0, 0, 0.5)'
      })
      try {
        const res = await getPageListData(
          url,
          {
            ...payload.queryInfo,
            ...state.orderInfo
          },
          'blob'
        )
        const blob = new Blob([res], {
          type: 'application/octet-stream'
        })
        const down = document.createElement('a')
        down.download = payload.filename
        down.style.display = 'none'
        down.href = URL.createObjectURL(blob)
        document.body.appendChild(down)
        down.click()
        URL.revokeObjectURL(down.href)
        document.body.removeChild(down)
      } finally {
        loadingInstance.close()
      }
    },

    async exportXlsx() {
      downloadData(
        `/live/statistic/downloadDay`,
        {
          channelId: 3
        },
        'blob'
      ).then((res) => {
        const blob = new Blob([res], {
          type: 'application/octet-stream'
        })
        const down = document.createElement('a')
        down.download = '与牛共舞666.xlsx'
        down.style.display = 'none'
        down.href = URL.createObjectURL(blob)
        document.body.appendChild(down)
        down.click()
        URL.revokeObjectURL(down.href)
        document.body.removeChild(down)
      })
    },

    async exportSummaryXlsx({ commit, state }, payload: any) {
      const pageName = payload.pageName as string
      const url = `/main/${pageName}/summary`
      const loadingInstance = ElLoading.service({
        lock: true,
        text: '数据下载中...',
        background: 'rgba(0, 0, 0, 0.5)'
      })
      try {
        const res = await getPageListData(
          url,
          {
            ...payload.queryInfo,
            ...state.orderInfo
          },
          'blob'
        )
        const blob = new Blob([res], {
          type: 'application/octet-stream'
        })
        const down = document.createElement('a')
        down.download = payload.filename
        down.style.display = 'none'
        down.href = URL.createObjectURL(blob)
        document.body.appendChild(down)
        down.click()
        URL.revokeObjectURL(down.href)
        document.body.removeChild(down)
      } finally {
        loadingInstance.close()
      }
    },

    connectWebSocket({ commit, state }, payload: any) {
      const currentSocket = state.webSocket
      if (
        currentSocket &&
        (currentSocket.readyState === WebSocket.CONNECTING ||
          currentSocket.readyState === WebSocket.OPEN)
      ) {
        return
      }

      const ws = new WebSocket(payload.url)
      commit('setWebSocket', ws)
      attachWindowFocusListeners()

      const releaseWebSocket = () => {
        if (state.webSocket !== ws) return
        commit('setWebSocket', null)
        detachWindowFocusListeners()
      }

      ws.addEventListener('open', () => {
        console.log('WebSocket connected')
      })
      ws.addEventListener('message', (event) => {
        const message = JSON.parse(event.data)
        if (isWindowFocused || typeof Notification === 'undefined') {
          ElNotification({
            title: message.sender,
            dangerouslyUseHTMLString: true,
            message:
              message.businessCode == 'IM_004'
                ? '每日跟踪标准小贴士'
                : message.msgContent,
            position: 'bottom-right',
            duration: 300000
          })
        } else {
          notifyMe(
            message.sender,
            message.businessCode == 'IM_004'
              ? '每日跟踪标准小贴士'
              : message.msgContent
          )
        }
        if (payload.callback && typeof payload.callback == 'function') {
          payload.callback()
        }
      })
      ws.addEventListener('close', () => {
        console.log('WebSocket disconnected')
        releaseWebSocket()
      })
      ws.addEventListener('error', (error) => {
        console.error('WebSocket error:', error)
        releaseWebSocket()
      })
    },
    disconnectWebSocket({ commit, state }) {
      const webSocket = state.webSocket
      commit('setWebSocket', null)
      detachWindowFocusListeners()
      if (
        webSocket &&
        (webSocket.readyState === WebSocket.CONNECTING ||
          webSocket.readyState === WebSocket.OPEN)
      ) {
        webSocket.close()
      }
    },
    sendWebSocketMessage({ state }, message: MessageType) {
      if (state.webSocket?.readyState === WebSocket.OPEN) {
        state.webSocket.send(JSON.stringify(message))
      }
    }
  }
}

export default systemModule
